import { useQuery } from '@tanstack/react-query';
import { patientCareTeamNextAppointments } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const usePatientCareTeamNextAppointmentsQuery = (patientId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'patient-care-team-next-sessions', patientId ],
    queryFn: async () => {
      const response = await patientCareTeamNextAppointments(patientId);

      return response.data;
    },
    ...opts
  });
};
